<template>
  <v-container fluid>
    <v-row justify="center" align="center" class="mt-4">
      <span class="title text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4 mb-8">
        Search Movie
      </span>
    </v-row>
    <v-toolbar style="background-color: var(--var1)">
      <!-- <v-app-bar-nav-icon class="hidden-sm-and-down"></v-app-bar-nav-icon> -->
      <v-toolbar-title class="text-h6 mr-6 hidden-sm-and-down">
        Movies
        <v-icon>mdi-movie-search-outline</v-icon>
      </v-toolbar-title>
      <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        chips
        clearable
        hide-details
        hide-selected
        item-text="Title"
        item-value="imdbID"
        label="Search for a movie..."
        solo
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-title>
              Search for your favorite
              <strong>movie</strong>
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-slot:selection="{ attr, on, item, selected }">
          <v-chip
            v-bind="attr"
            :input-value="selected"
            color="blue-grey"
            class="white--text"
            v-on="on"
          >
            <v-icon left>mdi-movie</v-icon>
            <span v-text="item.Title"></span>
          </v-chip>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-avatar
            color="indigo"
            class="text-h5 font-weight-light white--text"
          >
            {{ item.Title.charAt(0) }}
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="item.Title"></v-list-item-title>
            <v-list-item-subtitle v-text="item.Year"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-movie</v-icon>
          </v-list-item-action>
        </template>
      </v-autocomplete>
      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          centered
          :hide-slider="!model"
          color="blue-grey"
          slider-color="blue-grey"
        >
          <v-tab-item>
            <v-container fluid>
              <div
                :style="{
                  overflowY: 'scroll',
                  maxHeight: '500px',
                }"
              >
                <v-card flat>
                  <div v-if="movie[model]">
                    <v-card
                      elevation="5"
                      outlined
                      class="my-4 mx-4"
                      style="background-color: var(--cardMovie)"
                    >
                      <v-row class="white--text mb-10">
                        <v-col cols="12" sm="3" class="text-center">
                          <img
                            :style="{ width: '100%', maxWidth: '400px' }"
                            :src="movie[model].Poster"
                            :alt="movie[model].Title"
                          />
                        </v-col>
                        <v-col cols="12" sm="9" class="mt-2">
                          <v-row>
                            <v-col cols="12">
                              <p class="headline text-center font-weight-medium">
                                {{ movie[model].Title }}
                                <span class="caption"
                                  >{{ movie[model].Type }} ({{ movie[model].Year }})
                                </span>
                              </p>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-card-text>
                                <div class="caption font-weight-medium">
                                  <span style="color: var(--genreMovie)">
                                    {{ movie[model].Genre }}
                                  </span>
                                  <span class="mx-3 runTime">
                                    {{ movie[model].Runtime }}
                                  </span>
                                  <span class="mb-1 rated">
                                    {{ movie[model].Rated }}
                                  </span>
                                </div>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <v-card-text>
                                <div class="caption font-weight-medium">
                                  <div
                                    class="text-decoration-underline body-1 font-weight-bold mb-2"
                                  >
                                    Info
                                  </div>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Director </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Director }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Actors </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Actors }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Writer </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Writer }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Language </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Language }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Country </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Country }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Release </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Released }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Awards </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Awards }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> DVD </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].DVD }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Box Office </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].BoxOffice }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Production </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Production }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Website </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ movie[model].Website }}</v-col>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <v-card-text>
                                <div
                                  class="text-decoration-underline body-1 font-weight-bold mb-2"
                                >
                                  Rating
                                </div>
                                <div
                                  v-for="rating in movie[model].Ratings"
                                  :key="rating.Source"
                                >
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Source </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7">{{ rating.Source }}</v-col>
                                  </v-row>
                                  <v-row class="no-gutters">
                                    <v-col cols="4"> Ratings </v-col>
                                    <v-col cols="1">:</v-col>
                                    <v-col cols="7"> {{ rating.Value }}</v-col>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-card-text>
                                <div
                                  class="text-decoration-underline body-1 font-weight-bold mb-2"
                                >
                                  Plot :
                                </div>
                                <p>{{ movie[model].Plot }}</p>
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-card>
              </div>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </template>
    </v-toolbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null,
    tab: null,
    movie: {},
  }),
  created() {
    this.fetchMovie();
  },
  methods: {
    async fetchMovie(imdbID) {
      if (!imdbID || this.movie[imdbID]) return;
      const response = await axios.get("https://www.omdbapi.com", {
        params: {
          i: imdbID,
          apikey: "8da4e548",
        },
      });
      this.$set(this.movie, imdbID, response.data);
    },
  },
  watch: {
    model(val) {
      if (val != null) {
        this.tab = 0;
        this.fetchMovie(val);
      } else {
        this.tab = null;
      }
    },
    search(val) {
      this.isLoading = true;
      // Lazily load input items
      axios
        .get("https://www.omdbapi.com/?apikey=8da4e548&s=" + val)
        .then((response) => {
          this.items = response.data.Search;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style scoped>
.title {
  font-family: Roboto !important;
  font-size: 600 !important;
  color: var(--var2);
}
.runTime {
  display: inline-block;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid var(--genreMovie);
}

.rated {
  display: inline-block;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  background-color: var(--var5);
}
</style>
